import { take, takeEvery, fork, all, call } from 'redux-saga/effects';
import { apiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './classesStudentsActions';

export const removeGroupTask = apiTask(
  actions.REMOVE_GROUP,
  api.post,
  '/evaluation-system/removeGroup.php',
);

export function* watchRemoveGroup() {
  while (true) {
    const { payload } = yield take(actions.REMOVE_GROUP);
    yield call(removeGroupTask, payload);
    yield fork(getGroupsTask);
  }
}

export const getSchools = apiTask(
  actions.GET_SCHOOLS,
  api.get,
  '/evaluation-system/getSchools.php',
);

export function* watchGetSchools() {
  while (yield take(actions.GET_SCHOOLS)) {
    yield fork(getSchools);
  }
}

export const getGroupsTask = apiTask(
  actions.GET_GROUPS,
  api.post,
  '/evaluation-system/getGroups.php',
);
export function* watchGetGroups() {
  yield takeEvery(actions.GET_GROUPS, getGroupsTask);
}

export const massiveLoadGroups = apiTask(
  actions.MASSIVE_LOAD_GROUPS,
  api.post,
  '/evaluation-system/massiveLoadGroups.php',
);
export function* watchMassiveLoadGroups() {
  while (true) {
    const { payload } = yield take(actions.MASSIVE_LOAD_GROUPS);
    yield fork(massiveLoadGroups, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([
    fork(watchGetGroups),
    fork(watchGetSchools),
    fork(watchMassiveLoadGroups),
    fork(watchRemoveGroup),
  ]);
}
